/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

const headers = {
  isAuthRequired: true,
  "Content-Type": "application/json",
  "x-tenant-slug": "default",
};

export default {
  // params : { applicant_type?: "DRIVER" | "USER" | "BUSINESS", search?, page, limit }
  getVehicleLeasePurchaseList: (params) => {
    return axios.get(API_ENDPOINTS.GET_VEHICLE_LEASE_PURCHASES, { headers, params });
  },
  getVehicleLeasePurchase: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_VEHICLE_LEASE_PURCHASES}/${id}`, { headers });
  },
  // L'admin approuve ou rejette ici : { status: "APPROVED" | "REJECTED" }
  updateVehicleLeasePurchase: (id, data) => {
    return axios.put(`${API_ENDPOINTS.GET_VEHICLE_LEASE_PURCHASES}/${id}`, data, { headers });
  },
  // Suppression logique d'une demande non traitée
  deleteVehicleLeasePurchase: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_VEHICLE_LEASE_PURCHASES}/${id}`, { headers });
  },
};
